import {parsePhoneNumberWithError} from "libphonenumber-js";

export function formatPhoneNumber(e164: string): string {
    try {
        const parsed = parsePhoneNumberWithError(e164)
        return parsed.formatInternational()
    } catch (e) {
        return e164
    }

}